import styled from 'styled-components'

export const HeaderImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    height: 120px;
    width: 120px;
  }
`

HeaderImage.displayName = 'HeaderImage'

export const ButtonContainer = styled.div`
  button {
    & + button {
      margin-left: 10px;
    }
  }

  .black-button-cancel {
    color: var(--gray-900);
    border: none;

    &:hover {
      background-color: var(--gray-200);
      color: var(--gray-900);
    }
  }

  .black-button {
    background-color: var(--gray-900);
    border: none;

    &:hover {
      background-color: var(--gray-600);
    }
  }
`

ButtonContainer.displayName = 'ButtonContainer'
